import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = { class: "form-wrapper template-page-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "template-empty"
}
const _hoisted_6 = {
  key: 0,
  class: "template-empty"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "template-item-summary" }
const _hoisted_9 = { class: "template-item-name" }
const _hoisted_10 = {
  key: 0,
  class: "template-default-pill"
}
const _hoisted_11 = { class: "template-item-cols" }
const _hoisted_12 = {
  key: 0,
  class: "template-item-cols"
}
const _hoisted_13 = { class: "template-item-head-right" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "template-item-body"
}
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "crm-board-color-select" }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "template-col-links" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { class: "crm-board-color-select" }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = ["value"]
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Work"),
        _createElementVNode("div", { class: "page-bar-main" }, "Board Templates")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-light",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/decks')))
        }, "Back")
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_4, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"margin-bottom":"20px"} }, " Templates show up when someone adds a board. Picking one starts the board with these columns and tags, which can still be changed on the board afterwards. The default template is what the Default option and new task managers start with. With no default set, they get To Do, In Progress and Done. ", -1)),
        (!_ctx.canManage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Only admins can manage board templates."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_ctx.templates.length && !_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "No templates yet. Add one below."))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (t, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: t.ID || `new-${i}`,
                  class: "template-item"
                }, [
                  _createElementVNode("div", {
                    class: "template-item-head",
                    onClick: ($event: any) => (_ctx.toggleOpen(i))
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _createTextVNode(_toDisplayString(t.Name || '(untitled template)'), 1),
                        (t.IsDefault)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Default"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Columns, (col, ci) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: ci,
                            class: "template-col-chip",
                            style: _normalizeStyle('background:' + col.color)
                          }, _toDisplayString(col.name), 5))
                        }), 128))
                      ]),
                      (t.Tags.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Tags, (tag, ti) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: ti,
                                class: "template-tag-chip",
                                style: _normalizeStyle('background:' + tag.color)
                              }, _toDisplayString(tag.name), 5))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (t.ID && !t.IsDefault)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "template-make-default",
                            onClick: _withModifiers(($event: any) => (_ctx.setDefault(t)), ["stop"])
                          }, "Make Default", 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: _withModifiers(($event: any) => (_ctx.onDeleteTemplateClick(t)), ["stop"]),
                        class: "template-delete-icon",
                        fill: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24"
                      }, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("path", { d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z" }, null, -1)
                      ]))], 8, _hoisted_15)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["template-chevron", _ctx.openIndex == i ? 'open' : ''])
                      }, "▸", 2)
                    ])
                  ], 8, _hoisted_7),
                  (_ctx.openIndex == i)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[8] || (_cache[8] = _createElementVNode("h3", {
                          class: "template-label",
                          style: {"margin-top":"0"}
                        }, "Template name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((t.Name) = $event),
                          placeholder: "Template name"
                        }, null, 8, _hoisted_17), [
                          [_vModelText, t.Name]
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "template-label" }, "Description", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((t.Description) = $event),
                          placeholder: "Shown under the name when adding a board"
                        }, null, 8, _hoisted_18), [
                          [_vModelText, t.Description]
                        ]),
                        _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "template-label" }, [
                          _createTextVNode("Columns "),
                          _createElementVNode("span", { class: "template-hint" }, "(drag to reorder)")
                        ], -1)),
                        _createVNode(_component_draggable, {
                          modelValue: t.Columns,
                          "onUpdate:modelValue": ($event: any) => ((t.Columns) = $event),
                          handle: ".template-col-handle"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Columns, (col, ci) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: ci,
                                class: "template-col-row"
                              }, [
                                _cache[6] || (_cache[6] = _createElementVNode("span", {
                                  class: "template-col-handle",
                                  title: "Drag to reorder"
                                }, "⋮⋮", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((col.name) = $event),
                                  placeholder: "Column name"
                                }, null, 8, _hoisted_19), [
                                  [_vModelText, col.name]
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": ($event: any) => ((col.color) = $event)
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.colorPalette, (color, k) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: k,
                                        value: color.hex
                                      }, _toDisplayString(color.label), 9, _hoisted_22))
                                    }), 128))
                                  ], 8, _hoisted_21), [
                                    [_vModelSelect, col.color]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "color",
                                    "onUpdate:modelValue": ($event: any) => ((col.color) = $event),
                                    title: "Custom color"
                                  }, null, 8, _hoisted_23), [
                                    [_vModelText, col.color]
                                  ])
                                ]),
                                _createVNode(_component_svg_icon, {
                                  icon: "x",
                                  class: "template-remove",
                                  onClick: ($event: any) => (t.Columns.splice(ci, 1))
                                }, null, 8, ["onClick"])
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", {
                            class: "template-addlink",
                            onClick: ($event: any) => (t.Columns.push({ name: '', color: _ctx.NEW_COLUMN_COLOR }))
                          }, "+ Add Column", 8, _hoisted_25),
                          (t.Columns.length)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "template-addlink",
                                onClick: ($event: any) => (_ctx.applyDefaultColumnColors(t.Columns, _ctx.$store.state.colorPalette))
                              }, "Apply Default Colors", 8, _hoisted_26))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "template-label" }, [
                          _createTextVNode("Tags "),
                          _createElementVNode("span", { class: "template-hint" }, "(optional, drag to reorder)")
                        ], -1)),
                        _createVNode(_component_draggable, {
                          modelValue: t.Tags,
                          "onUpdate:modelValue": ($event: any) => ((t.Tags) = $event),
                          handle: ".template-col-handle"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.Tags, (tag, ti) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: ti,
                                class: "template-col-row"
                              }, [
                                _cache[7] || (_cache[7] = _createElementVNode("span", {
                                  class: "template-col-handle",
                                  title: "Drag to reorder"
                                }, "⋮⋮", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((tag.name) = $event),
                                  placeholder: "Tag name"
                                }, null, 8, _hoisted_27), [
                                  [_vModelText, tag.name]
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": ($event: any) => ((tag.color) = $event)
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.colorPalette, (color, k) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: k,
                                        value: color.hex
                                      }, _toDisplayString(color.label), 9, _hoisted_30))
                                    }), 128))
                                  ], 8, _hoisted_29), [
                                    [_vModelSelect, tag.color]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "color",
                                    "onUpdate:modelValue": ($event: any) => ((tag.color) = $event),
                                    title: "Custom color"
                                  }, null, 8, _hoisted_31), [
                                    [_vModelText, tag.color]
                                  ])
                                ]),
                                _createVNode(_component_svg_icon, {
                                  icon: "x",
                                  class: "template-remove",
                                  onClick: ($event: any) => (t.Tags.splice(ti, 1))
                                }, null, 8, ["onClick"])
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", {
                          class: "template-addlink",
                          onClick: ($event: any) => (t.Tags.push({ name: '', color: '#000000' }))
                        }, "+ Add Tag", 8, _hoisted_32),
                        _createElementVNode("input", {
                          class: _normalizeClass(t._saving ? 'disable-button' : ''),
                          type: "submit",
                          value: "Save Template",
                          onClick: ($event: any) => (_ctx.saveTemplate(t))
                        }, null, 10, _hoisted_33)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", {
                  class: "add-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addTemplate()))
                }, "+ Add Template")
              ])
            ], 64))
      ])
    ], 2),
    (_ctx.templatePendingDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteTemplateConfirmed())),
          onCancel: _cache[3] || (_cache[3] = () => { _ctx.templatePendingDelete = null; }),
          msg: _ctx.deleteTemplateConfirmMsg
        }, null, 8, ["msg"]))
      : _createCommentVNode("", true)
  ]))
}